import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
interface PatternConfig {
  regex: RegExp;
  infoText: string;
}

export function patternValidator(config: PatternConfig): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = config.regex.test(control.value);
    return forbidden
      ? null
      : {
          pattern: {
            actualValue: control.value,
            requiredPattern: config.infoText,
          },
        };
  };
}
